
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visualization",
      function () {
        return require("private-next-pages/visualization/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visualization"])
      });
    }
  